<script>
  export default {
    name: "AppNenuphar"
  }
</script>

<template>
  <div class="lily-pad"></div>
</template>

<style>
.lily-pad {
  width: 100px;
  height: 60px;
  background-color: #6aa84f;
  border-radius: 50%;
  position: relative;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.14);
}

/* Créer une découpe dans le cercle */
.lily-pad::before {
  content: '';
  position: absolute;
  width: 55px;
  height: 50px;
  clip-path: polygon(50% 20%, 100% 50%, 50% 80%, 0% 50%);
  background-color: #7ff1f1;
  top: 5px;
  left: 70px;
}

</style>